import { render, staticRenderFns } from "./batchList.vue?vue&type=template&id=19e0bef8"
import script from "./batchList.vue?vue&type=script&lang=js"
export * from "./batchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports